define('views/modules/member/member/lists/member-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils', 'debug',
    // services
    'services/api',
    'services/i18n',
    'services/user',
    'services/session',
    'services/toastr-service',
    // events
    'services/events/conversation-events',
    // views
    'views/parts/media-info-box',
    'views/parts/popup/activation-link',
    'views/modules/supervisor/supervisor-icon',
    // models
    'models/conversation/conversation',
    'collections/conversation/conversations',
    // templates
    'text!templates/modules/member/member/lists/member-list-item.html',
    'text!templates/parts/popup/activation-link.html'
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U, DEBUG,
    // src
    API,
    i18n,
    User,
    Session,
    ToastrService,
    // events
    ConversationEvents,
    // views
    VMediaInfoBox,
    VActivationLinkPopup,
    VSupervisorIcon,
    // models
    MConversation,
    CConversations,
    // templates
    TMemberListItem,
    TActivationLinkPopup
) {

    var VMemberItem = Backbone.View.extend({
        className: "feedback level-10",
        template: TMemberListItem,

        regions: {
            infobox: ".item-section",
            subSection: ".sub-section",
        },
        initialize: function(opt) {
            this.options = _.extend({}, opt);

            var conversations = this.conversations = new CConversations();
            _.extend(this, {
                supervisors: opt.supervisors
            });

            this.view = {
                infobox: new VMediaInfoBox({
                    title: 'name',
                    subtitle: 'email',
                    tinyinfo: 'groupName',
                    photo: "thumbnail",
                    model: this.model,
                    context: this,
                    onClick: this.onClick,
                    extraPhotoContent: true,
                    menu: {
                        init: this.onMenuInit,
                        onClick: this.onActionClick,
                    }
                }),
            };

            this.listenTo(this.model, { 'remove': this.remove })
                .listenTo(Backbone.history, "route", this.onRoute);
        },
        render: function() {
            this.$el.empty().append(Mustache.render(this.template));

            // Add Feedback Class
            this.setFeedbackClass();

            this.generateZones();

            if (User.is(this.model)) {
                this.$el.addClass('myself');
                this.view.infobox.enableMenu(false);
            }

            this.assign(this.view.infobox, this.regions.infobox);

            this.setActive()
                .setExtraPhotoContent();

            return this;
        },

        isActive: function() {
            return this.zone.$infobox.hasClass('active');
        },

        isReferencedInUrl: function() {
            var fragment = Backbone.history.getFragment();
            if (fragment.indexOf('member/me/') > -1 && User.id === this.model.id) return true;

            return Backbone.history.getFragment().indexOf(this.model.id) > -1;
        },

        setExtraPhotoContent: function() {
            var view = this.view;
            if (this.isSupervisor()) {
                var supervisorIcon = view.supervisorIcon || (view.supervisorIcon = new VSupervisorIcon());
                view.infobox.setExtraPhotoContent(supervisorIcon.render().el);
            }
        },

        setActive: function(val) {
            if (_.isUndefined(val)) {
                val = this.isReferencedInUrl();
            }
            this.view.infobox.setActive(val);
            return this;
        },

        setFeedbackClass: function() {
            var feedback = this.model.getFeedback();
            if (!feedback) return;

            this.$el.removeClassPrefix("level-")
                .addClass("level-" + feedback);
        },

        deleteMember: function(result) {
            if (!result) return;
            this.model.destroy({
                context: this,
                wait: true,
                success: function(user) {
                    if (user.id === User.id) {
                        User.set('isHiddenFromClientsList', true);
                    }
                },
                error: function(model, response) {
                    // FIXME add error notification when member deletion failed
                    if (response.responseJSON) {
                        U.warn(response.responseJSON.message);
                    }
                }
            });

        },

        getCurrentConversation: function() {
            var modelId = this.model.id;
            return this.conversations.models.find(function(conversation) {
                return conversation.getUsersWithoutMe().includes(modelId);
            });
        },

        sendMessage: function(result) {
            if (result) {
                var conversation = this.getCurrentConversation(),
                    attributes = {
                        message: result
                    };

                if (!conversation) {
                    conversation = new MConversation();
                    conversation.setUser(this.model.id);
                    attributes = _.extend(attributes, _.omit(conversation.attributes, 'message'));
                }

                conversation.save(attributes, {
                    type: 'POST',
                    context: this,
                    silent: true,
                    success: function() {
                        ToastrService.success('your-message-has-been-succesfully-sent');
                    }
                });
            }
        },

        showActivationLinkPopup: function(response) {
            var url = window.env.APP_DOMAIN + "#/auth/login/" + response.access_token;
            var popupContent = new VActivationLinkPopup({
                message: i18n.t("Please send this link to the member through E-Mail or instant messaging."),
                alreadyActive: this.model.isActive(),
                url: url,
            });

            var buttons = {
                confirm: {
                    label: '<i class="fa fa-times"></i> Close',
                }
            };

            if (!this.model.isActive()) {
                buttons = _.extend({
                    cancel: {
                        label: '<i class="fa fa-clipboard"></i> Copy to clipboard',
                        callback: function() {
                            popupContent.copyLink();
                        }
                    },
                }, buttons);
            }

            Bootbox.dialog({
                title: i18n.t("Activation Link"),
                message: popupContent.render(),
                onEscape: true,
                backdrop: true,
                buttons: buttons,
            });
        },

        isSupervisor: function() {
            return Boolean(this.supervisors.get(this.model));
        },

        getConversationUrl: function() {
            var fragment = "#/supervisor/group/{{groupId}}/member/{{userId}}/messages/";

            return Mustache.render(fragment, Mustache.getContext({
                groupId: this.model.get('_mainGroupId'),
                userId: this.model.id
            }));
        },

        ////////////
        // events //
        ////////////

        onRoute: function(router, route, params) {
            if (this.model.get("_id") === params[1]) {
              this.setActive(true);
            }
        },

        onClick: function(e) {
            if (!this.isActive()) {
                this.setActive(false);
                this.model.trigger('click', this.model);
            }
        },

        onMenuInit: function() {
            User.setSelectedUser(this.model);
            // message options
            var menuActions = new Backbone.Collection();
            //Edit settings is availlable for all account
            menuActions.add([
                { caption: 'Edit', icon: "sl-icon-note", callback: this.onEditAction },
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction }
            ]);

            // Delete and Send Message isn't available on yourself
            if (!User.is(this.model.id)) {
                menuActions.add([
                    { caption: 'Send message', icon: "sl-icon-envelope", callback: this.onSendMessageAction }
                ]);
            }
            if (this.model.get('_isPending')) {
                menuActions.add([
                    { caption: 'Resend invitation', icon: "sl-icon-user-follow", callback: this.onResendInvitationAction },
                    { caption: 'Get activation link', icon: "sl-icon-link", callback: this.onGetActivationLinkAction }
                ]);
            }

            if (menuActions.length === 0) {
                menuActions.add([{ caption: 'No action available for this user' }]);
            }

            return menuActions;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onEditAction: function(e) {
            this.model.trigger('edit', this.model);
        },

        onDeleteAction: function() {
            Bootbox.confirm({
                title: i18n.t("Delete member"),
                message: i18n.t("messages:message-delete-member"),
                onEscape: true,
                backdrop: true,
                callback: this.deleteMember,
                context: this,
            });
        },

        onSendMessageAction: function() {
            Backbone.history.navigate(this.getConversationUrl(), true);
            ConversationEvents.redirectedToConversation();
        },

        onResendInvitationAction: function(e, item) {
            var url = Mustache.render("{{{urlRoot}}}{{{userId}}}", {
                urlRoot: this.model.urlRoot(),
                userId: this.model.id
            });

            var data = {
                _sendInvite: true,
            };

            return Backbone.ajax(
                _.extend({
                    url: url,
                    method: "PATCH",
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify(data),
                }, {
                    success: function() {
                        ToastrService.success('resend-invitation-success');
                    }
                })
            );
        },

        onGetActivationLinkAction: function(e, item) {
            var requestParam = Mustache.render("?username={{{username}}}&client_id={{{client_id}}}", {
                    username: encodeURIComponent(this.model.attributes.email),
                    client_id: "testclientid",
                }),
                member_item = this;

            return Backbone.ajax(
                _.extend({
                    url: API.url("oauth2/token") + requestParam,
                    method: "GET",
                    context: this,
                }, {
                    success: function(response, textStatus, xhr) {
                        this.showActivationLinkPopup(response, this);
                    },
                })
            );
        },
    });

    return VMemberItem;

});

